// Translations for the SMS Logs page (frontend/src/pages/SmsLogs/SmsLogs.js)
const smsLogsDict = [
  { en: "SMS Logs", sw: "Kumbukumbu za SMS" },
  { en: "Every SMS sent by the system and whether the gateway accepted it", sw: "Kila SMS iliyotumwa na mfumo na kama mtoa huduma aliikubali" },
  { en: "Sent (30 days)", sw: "Zilizotumwa (siku 30)" },
  { en: "Failed (30 days)", sw: "Zilizoshindwa (siku 30)" },
  { en: "Search phone, message or reference", sw: "Tafuta namba, ujumbe au kumbukumbu" },
  { en: "All statuses", sw: "Hali zote" },
  { en: "Sent", sw: "Imetumwa" },
  { en: "Failed", sw: "Imeshindwa" },
  { en: "No SMS records yet.", sw: "Bado hakuna kumbukumbu za SMS." },
  { en: "Source", sw: "Chanzo" },
  { en: "Gateway response", sw: "Jibu la mtoa huduma" },
  { en: "Job application", sw: "Ombi la kazi" },
  { en: "Invitation", sw: "Mwaliko" },
  { en: "System", sw: "Mfumo" },
];

export default smsLogsDict;
